exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LinkButtons2 .link-buttons{border-width:1px;border-style:none solid solid none}.LinkButtons2 .link-button{border-width:1px;border-style:solid none none solid}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/LinkButtons2/src/components/contents/LinkButtons2/LinkButtons2.s.scss"],"names":[],"mappings":"AAEA,4BAEI,iBAAiB,AACjB,kCAAmC,CACpC,AAJH,2BAMI,iBAAiB,AACjB,kCAAmC,CACpC","file":"LinkButtons2.scss","sourcesContent":["@import '~scss/variables';\n\n.LinkButtons2 {\n  .link-buttons {\n    border-width: 1px;\n    border-style: none solid solid none;\n  }\n  .link-button {\n    border-width: 1px;\n    border-style: solid none none solid;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/LinkButtons2/LinkButtons2.scss
// module id = 1012
// module chunks = 114